import React from 'react';
import './Footer.scss';

function Footer() {
  return (
    <footer>
      Données provenant d'<a href="https://world.openfoodfacts.org/">Open Food Facts</a>
    </footer>
  );
}

export default Footer;
